import { render, staticRenderFns } from "./LoanRequestHistory.vue?vue&type=template&id=6c2f92ea&"
import script from "./LoanRequestHistory.vue?vue&type=script&lang=js&"
export * from "./LoanRequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports